<div class="h-[99px]">
  <div class="padding2 py-4 h-full flex items-center justify-between">
    <div>
      <a href="/">
        <img
          src="voyagex-jobs-logo.png"
          alt="VoyageX Jobs Logo"
          class="h-[50px] w-[200px] aspect-auto"
          loading="lazy"
          width="auto"
          height="30"
        />
      </a>
    </div>
    <div>
      <!-- <ul>
        <li class="hover:underline hover:cursor-pointer">
          <a href="/companies" class="font-light"> Companies </a>
        </li>
      </ul> -->
    </div>
  </div>
</div>
